import { createApp } from 'vue';

import vueClickOutsideElement from 'vue-click-outside-element';

import Courses from './components/Courses.vue'

/* Global store */
import store from './store.js';

/* App */
const coursesEl = document.querySelector('#courses');

/* Global methods */
const app = createApp(Courses, { filterTopic: coursesEl.dataset.filterTopic });

/* Global methods */
app.mixin({
	computed: {
		/* If everything is loaded */
		ready: {
			get() {
				return this.$store.ready || false;
			},
			set(value) {
				this.$store.ready = value;
			},
		},

		/* List of course objects */
		courses: {
			get() {
				return this.$store.courses || [];
			},
			set(value) {
				this.$store.courses = value;
			},
		},

		/* List of topics */
		topics: {
			get() {
				return this.$store.topics || {};
			},
			set(value) {
				this.$store.topics = value;
			},
		},

		/* List of roles */
		roles: {
			get() {
				return this.$store.roles || {};
			},
			set(value) {
				this.$store.roles = value;
			},
		},

		/* List of experiences from store */
		experiences: {
			get() {
				return this.$store.experiences || {};
			},
			set(value) {
				this.$store.experiences = value;
			}
		},

		/* Current filters */
		filter() {
			return this.$store.filter || {
				topics: [],
				roles: [],
				// experiences: [],
			};
		},
	},

	methods: {
		/* Sort an array of term objects alphabetically */
		sortTerms(a, b) {
			if (a.term < b.term) {
				return -1;
			}

			if (a.term > b.term) {
				return 1;
			}

			return 0;
		},

		/* Set taxonomy filter value predictably */
		setFilter(selection, type = 'topics') {
			/* Ensure the selection applied is always an array */
			if (Array.isArray(selection)) {
				this.$store.filter[type] = selection.length > 0 ? selection : [];
			} else if (selection) {
				this.$store.filter[type] = [selection];
			} else {
				this.$store.filter[type] = [];
			}
		},

		getFilteredCourses(roles, topics, experiences) {
			/* Filter the full list of courses */
			return this.courses.filter(course => {
				/* Get a list of terms in the current course */
				const courseTopics = course.taxonomies?.topic ? course.taxonomies?.topic.map(topic => topic.slug) : [];
				const courseRoles = course.taxonomies?.role ? course.taxonomies?.role.map(role => role.slug) : [];
				const courseExperiences = course.taxonomies?.experience ? course.taxonomies?.experience.map(experience => experience.slug) : [];

				/* Check if the selected filter has overlap with the term list */
				/* If no filter is selected for a particular taxonomy, return true (= user wants all courses for that taxonomy) */
				const isTopicMatch = topics.length > 0 ? topics.some(topic => courseTopics.includes(topic)) : true;
				const isRoleMatch = roles.length > 0 ? roles.some(role => courseRoles.includes(role)) : true;
				const isExperienceMatch = experiences.length > 0 ? experiences.some(experience => courseExperiences.includes(experience)) : true;

				/* Only return courses that are a match for all taxonomy dimensions */
				return isTopicMatch && isRoleMatch && isExperienceMatch;
			});
		},
	},
});

// Vue.use(vueClickOutsideElement);
app.use(store);
app.use(vueClickOutsideElement);

/* Course browser */
app.mount('#courses');
